import React, { useMemo } from 'react';
import { useGetCustomViewsQuery } from '../../../../API/pcDashboard/CustomViewsApi';
import { useHistory } from 'react-router';
import { KeyboardShortcut } from '../../../shared/InteractionManagement/KeyboardShortcut';
import { clientUrls } from '../../../../ui-toolkit/rest/ClientUrlFactory';
import { useCustomViewsContext } from './context/CustomViewsContext';

export const KeyboardShortcutsList: React.FC = () => {
  const { data = {} } = useGetCustomViewsQuery();
  const listOfShortcuts = useMemo(() => Object.values(data), [data]);
  const history = useHistory();
  const { resetContext } = useCustomViewsContext();

  return (
    <>
      {listOfShortcuts.map((shortcutDatum) => (
        <KeyboardShortcut
          key={shortcutDatum.id}
          triggerKey={shortcutDatum.keyboardKey}
          onAction={() => {
            resetContext();
            history.push(`${clientUrls.urlFor.dashboard()}${shortcutDatum.search}`);
          }}
        />
      ))}
    </>
  );
};
